/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Format_LabelInputs */



/**
* | output |
* | --- |
* | "Format" |
*
* @param {Dialogue_List_Export_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_format_label = /** @type {((inputs?: Dialogue_List_Export_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format")
	if (locale === "de") return /** @type {LocalizedString} */ ("Format")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Формат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("形式")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatar")
	return /** @type {LocalizedString} */ ("Format")
});